import A11yPopupButton from '../../a11y/modules/a11y-popup-button'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default class Place {
  constructor(element) {
    this.trigger = element

    const targetId = this.trigger.getAttribute('aria-controls')
    this.target = document.getElementById(targetId)

    this.instance = new A11yPopupButton(this.trigger)
    this.instance.init()

    this.target.addEventListener('keyup', (event) => {
      if (event.key === 'Escape' && this.instance.active) {
        this.instance.closePopup(true)
      }
    })

    const mediaQuery = window.matchMedia('(max-width: 1023px)')

    if (mediaQuery.matches) {
      this.target.addEventListener('A11yPopupOpen', () => {
        disableBodyScroll(this.target)
      })

      this.target.addEventListener('A11yPopupClose', () => {
        enableBodyScroll(this.target)
      })
    }

    window.addEventListener('A11yPopupOpen', ({ detail: { A11yPopup } }) => {
      if (
        this.trigger != A11yPopup.controller.node &&
        this.target != A11yPopup.node
      ) {
        this.instance.closePopup(false)
      } else {
        this.target.scrollTop = 0
      }
    })
  }
}
